import type React from 'react';
import type { ComponentProps } from 'react';

import LoadingIcon from 'components/atoms/LoadingIcon';
import { cn } from 'utils/cn';
import { ConfirmationIcon } from '../Icons';
import { Stack } from '../Stack';

export interface AgentWizardOptionButtonProps extends ComponentProps<'button'> {
  isSelected: boolean;
  isLoading?: boolean;
  shouldShowSelectedIcon?: boolean;
  onClick: () => void;
}

export const AgentWizardOptionButton: React.FC<
  AgentWizardOptionButtonProps
> = ({
  isSelected,
  isLoading,
  shouldShowSelectedIcon = true,
  children,
  ref: _ref,
  ...rest
}) => {
  return (
    <button
      className={cn(
        'cursor-pointer flex items-center justify-between w-full h-md2 px-xs3 py-xs1 bg-background border rounded-medium transition-[background-color,border-color] duration-200 ease-in-out hover:bg-background-hover',
        isSelected
          ? 'border-border-primary hover:border-border-primary'
          : 'border-border-subtle hover:border-border-strong',
      )}
      {...rest}
    >
      {children}
      {isLoading ? (
        <Stack align="center" height="20px" justify="center" width="20px">
          <LoadingIcon />
        </Stack>
      ) : (
        <ConfirmationIcon
          color={
            isSelected && shouldShowSelectedIcon ? 'iconPrimary' : 'background'
          }
        />
      )}
    </button>
  );
};
